<script lang="ts" setup>
const { t } = useI18n()
const route = useRoute()

useSeoMeta({
  description: t('seo.description'),
  title: t('seo.title'),
})
</script>

<template>
  <UContainer class="-mt-10 min-h-screen py-20 md:-mt-8">
    <NuxtPage v-if="route.params.slug" />

    <SectionUseCases
      v-else
      is-main-section
    />
  </UContainer>

  <div class="relative">
    <div class="flex flex-col items-center justify-center pb-20">
      <BaseHeading
        class="mb-6"
        :description="t('contact.description')"
        size="sm"
        tag="h2"
        :title="t('contact.title')"
      />

      <ButtonChat
        class="gradient-texture rounded-full"
        size="xl"
      />
    </div>

    <LayoutBackground
      image="map"
      reverse
    />
  </div>
</template>

<i18n lang="json">
{
  "en": {
    "contact": {
      "description": "Reach out to us in the chat below, and let's solve it together!",
      "title": "Need help implementing your use case?"
    },
    "seo": {
      "description": "Discover how to leverage our API to gain a competitive edge in the market.",
      "title": "Use cases | The Companies API"
    }
  },
  "es": {
    "contact": {
      "description": "¡Contáctanos a través del chat de abajo y lo solucionamos juntos!",
      "title": "¿Necesitas ayuda para implementar tu caso de uso?"
    },
    "seo": {
      "description": "Descubre cómo utilizar nuestra API para obtener una ventaja competitiva en el mercado.",
      "title": "Casos de uso | The Companies API"
    }
  },
  "fr": {
    "contact": {
      "description": "Contactez-nous via le chat ci-dessous, et trouvons la solution ensemble !",
      "title": "Besoin d'aide pour implémenter votre cas d'utilisation ?"
    },
    "seo": {
      "description": "Découvrez comment utiliser notre API pour prendre de l'avance sur votre marché.",
      "title": "Cas d'utilisation | The Companies API"
    }
  }
}
</i18n>
